import React, { useState } from 'react'
import login_page from "../assets/login_page.jpg"
import axios from 'axios'
import { API } from './constant'

import { ToastContainer, toast } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";

import contact_boy from "../assets/Landing_page/contact_boy.png"

// css file start 
import "./contact.css"
// css file end

// icons 
import { FaEye } from "react-icons/fa";
import { FaEyeSlash } from "react-icons/fa";
import LandingHeader from './LandingHeader';
import FooterOther from './FooterOther';
const Login = () => {

    const [Email, setEmail] = useState("")
    const [Password, setPassword] = useState("")
    const [viewPassword, setviewPassword] = useState(false)

    // login start 
    const HandleLogin = async () => {
        const data = {
            email: Email,
            password: Password
        }
        await axios.post(`${API}/login`, data)
            .then((res) => {
                // console.log(res.data)
                localStorage.setItem("token", res.data.token)
                toast.success(res.data.message)
                setTimeout(() => {
                    window.location.href = "/students"
                }, 3000);
            })
            .catch((error) => {
                console.log(error)
                // alert(error.response.data.message)
                toast.warning(error.response.data.message, { theme: "colored" })
            })
    }
    // login end

    // onkeypress enter key start 
    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            HandleLogin()
        }
    }
    // onkeypress enter key end

    // return (

    //         <div className='bg-[#eea3f7] h-screen  flex justify-center items-center'>
    //             <ToastContainer position="top-right" autoClose={3000} />


    //             {/* <div className=' flex justify-center items-center h-[500px] w-[50%] shadow-lg shadow-black'> */}
    //             <div className='flex justify-center items-center  bg-white   h-[60%] md:w-[50%] w-[90vw] shadow-lg shadow-black rounded-md'>
    //                 {/* header start  */}
    //                 {/* <header className="bg-purple-500 text-white p-4 sticky top-0 z-10 shadow-md">
    //                 <div className="px-[20px] mx-auto flex justify-between items-center">
    //                     <h1 className="text-2xl md:text-3xl font-bold flex items-center gap-2">
    //                         <span role="img" aria-label="book">📖</span> Jaipuria Lexile Programme
    //                     </h1>
    //                     <nav className="hidden md:flex gap-4">
    //                         <a href="#home" className="hover:underline">Home</a>
    //                     </nav>
    //                     <button className="md:hidden text-2xl">☰</button>
    //                 </div>
    //             </header> */}
    //                 {/* header end */}

    //                 <div className='md:w-[55%] w-full p-[20px] md:px-[60px]  py-[50px] h-auto  grow-0'>
    //                     <div className='w-full text-center sm:text-justify'>
    //                         <h2 className='text-[#374CC3] text-[20px] lg:text-[25px] font-medium'>Hello,</h2>
    //                         <h2 className='text-[#3648FE] text-[20px] lg:text-[30px] font-bold leading-[30px] text-nowrap' >Welcome to </h2>
    //                         <h2 className='text-[#3648FE] md:text-[20px] lg:text-[30px] font-bold leading-[30px] text-nowrap' >Jaipuria Lexile Portal!</h2>
    //                         {/* <h2 className='text-[#3648FE] text-[20px] lg:text-[30px] font-bold leading-[30px] text-nowrap' >SRJ Lexile Portal!</h2> */}

    //                     </div>
    //                     <div className='border-[1px] border-black-400 px-[5px] py-[8px] mt-[20px] '>
    //                         <div className='py-[5px]'>
    //                             <label htmlFor="">Email Address</label>
    //                         </div>
    //                         <div>
    //                             <input value={Email} onChange={(e) => setEmail(e.target.value)} className='w-full px-[5px] py-[3px] outline-none border-[1px] border-grey rounded-md' type="Email" required />
    //                         </div>
    //                     </div>
    //                     <div className='border-[1px] border-black-400 px-[5px] py-[8px] '>
    //                         <div className='py-[5px]'>
    //                             <label htmlFor="">Password</label>
    //                         </div>
    //                         <div className='flex gap-2 items-center'>
    //                             <input value={Password} onChange={(e) => setPassword(e.target.value)} onKeyDown={handleKeyPress} className='w-full px-[5px] py-[3px] outline-none border-[1px] border-grey rounded-md' type={`${viewPassword ? "text" : "password"}`} />
    //                             {
    //                                 viewPassword ?
    //                                     <FaEyeSlash size={25} onClick={() => setviewPassword(!viewPassword)} /> : < FaEye size={25} onClick={() => setviewPassword(!viewPassword)} />
    //                             }
    //                         </div>
    //                     </div>

    //                     <div className='mt-[20px]'>
    //                         <button onClick={HandleLogin} className='bg-[#FD27FF] px-[20px] py-[5px] text-white font-semibold'>Login</button>
    //                     </div>
    //                 </div>
    //                 <div className='w-[45%] h-full grow-0 md:block hidden'>
    //                     <div className='h-full'>
    //                         <img className='h-[100%] w-full  rounded-tl-none rounded-bl-none rounded-md' src={login_page} alt="" />
    //                     </div>
    //                 </div>
    //             </div>
    //             {/* </div> */}

    //         </div>


    // )


    return (
        <div>
            <ToastContainer position="top-right" autoClose={3000} />

            <LandingHeader />
            <div className='h-[90vh] xl:h-[100vh] w-full flex justify-center items-center'>

                <div className='h-[60vh] xl:h-[80vh] w-[90%] lg:w-[80%] bg-main_color lg:rounded-[40px] relative overflow-hidden  mt-[0px] lg:mt-[120px]'>
                    <div className='flex justify-around  '>
                        <div className='w-[95%] lg:w-[40%] my-[30px] xl:my-[60px]'>
                            <h2 className='text-[44px] text-white '>Login</h2>
                            <div className='my-[20px]'>
                                <label className='text-white_color text-[14px]' >Email</label>
                                <div>
                                    <input value={Email} onChange={(e) => setEmail(e.target.value)} className='input_border_login py-[]' type="text" placeholder='username@gmail.com' />
                                </div>
                            </div>
                            <div>
                                <label className='text-white_color text-[14px]' >Password</label>
                                <div className='flex gap-2 items-center bg-white_color'>
                                    <input value={Password} onChange={(e) => setPassword(e.target.value)} onKeyDown={handleKeyPress} type={`${viewPassword ? "text" : "password"}`} className="input_border_login" placeholder='Password' />
                                    {
                                        viewPassword ?
                                            <FaEyeSlash size={25} onClick={() => setviewPassword(!viewPassword)} /> : < FaEye size={25} onClick={() => setviewPassword(!viewPassword)} />
                                    }
                                </div>
                            </div>

                            <div className='my-[20px]'>
                                <button onClick={HandleLogin} className='button_red_login w-full'>
                                    Sign in
                                </button>
                            </div>
                        </div>
                        <div className='hidden lg:block'>
                            <div className='w-[90%]'>
                                <img className='absolute right-0' src={contact_boy} alt="contact boy image" />
                            </div>
                        </div>
                    </div>


                </div>



            </div>


            {/* enquiry section start  */}
            <div className=''>
                <div className='FJCIC'>
                    <h2 className=' text-main_color font-[400] text-[30px] lg:text-[44px] from-neutral-50 mt-[20px]'>For More Enquiry</h2>
                </div>

                <div className='flex justify-center text-main_color font-normal text-[14px] w-full '>
                    <div className='w-[90%] lg:w-[50%] text-center'>
                        <p className='w-full '>
                            Have questions or need more information? We’re here to help! Reach out to us for any enquiry, feedback, or support. Our team will get back to you promptly. Contact us directly—we’d love to hear from you!
                        </p>
                    </div>

                </div>
                <div className='flex justify-center my-[20px]'>
                    <a href="/contact-us"><button className='button_red'>Contact Us</button></a>
                </div>
            </div>
            {/* enquiry section end */}

            <FooterOther />
        </div>
    )
}

export default Login